import styled from 'styled-components';

export const Container = styled.section`
  margin-top: 12rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  .hard-skills {
    margin-top: 1.6rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.8rem;
  }

  .certification {
    margin-top: 3rem;
    display: flex;
    align-items: center;
    gap: 2.4rem;
    padding: 2rem 2.4rem;
    border-radius: 1.6rem;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 1.2rem 3.2rem rgba(0, 0, 0, 0.25);
  }

  .certification img {
    width: 10rem;
    min-width: 8rem;
    filter: drop-shadow(0 0.4rem 0.8rem rgba(0, 0, 0, 0.35));
  }

  .certification-details {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    text-align: left;
  }

  .credential-link {
    align-self: flex-start;
    padding: 0.8rem 2.4rem;
    border-radius: 999px;
    background: var(--green);
    color: #fff;
    font-weight: 600;
    font-size: 1.4rem;
    transition: filter 0.25s ease;

    &:hover {
      filter: brightness(0.85);
    }
  }

  .hability {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 3.4rem;
    }
  }

  h2 {
    display: inline-block;
    margin-bottom: 2rem;
    // border-bottom: 0.2rem solid var(--blue);
    font-size: 3rem;
    margin-top: 0rem;
    color: var(--green);
  }

  h3 {
    margin-top: 2rem;
    color: var(--green);
  }

  p {
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    font-weight: 500;
  }

  .about-image {
    text-align: center;

    img {
      margin-top: 2rem;
      width: 75%;
      filter: grayscale(0);
      transition: filter 0.5s;

      &:hover {
        filter: grayscale(0);
      }
    }
  }

  @media (max-width: 960px) {
    display: block;
    text-align: center;

    .hard-skills {
      justify-content: center;
    }

    .certification {
      justify-content: center;
    }

    .certification-details {
      text-align: center;
      align-items: center;
    }

    .credential-link {
      align-self: center;
    }

    .about-image {
      display: flex;
      max-width: 100%;

      img {
        margin-top: 2rem;
        width: 100%;
        filter: grayscale(0);
        transition: filter 0.5s;

        &:hover {
          filter: grayscale(0);
        }
      }
    }
  }

  @media (max-width: 480px) {
    .certification {
      flex-direction: column;
      text-align: center;
      gap: 1.6rem;
    }

    .about-image {
      max-width: 100%;
      margin-top: 4rem;

      img {
        margin-top: 2rem;
        width: 100%;
        filter: grayscale(0);
        transition: filter 0.5s;

        &:hover {
          filter: grayscale(0);
        }
      }
    }
  }
`;
